import * as jsxRuntime from "C:\\workspace\\front-end-development\\shiftwagon-web\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment